import React from 'react';
import styled from 'styled-components';
import { standardColours, brandColours, fontSize } from '../../styles';

const StyledDateRange = styled.span`
  display: inline-block;
  padding: 3px 8px 5px;
  color: ${standardColours.white};
  ${fontSize(14)};
  background-color: ${brandColours.secondary};
  border-radius: 15px;
`;

export const DateRange = ({ startDate, endDate, ...props }) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  const startDay = start.getDate();
  const startMonth = start.toLocaleString('default', { month: 'short' });
  const startYear = start.getFullYear();
  const endDay = end.getDate();
  const endMonth = end.toLocaleString('default', { month: 'short' });
  const endYear = end.getFullYear();

  const formatDay = day => {
    let suffix;

    switch (day % 10) {
      case 1:
        suffix = 'st';
        break;
      case 2:
        suffix = 'nd';
        break;
      case 3:
        suffix = 'rd';
        break;
      default:
        suffix = 'th';
    }

    if (day > 3 && day < 21) {
      suffix = 'th';
    }

    return `${day}${suffix}`;
  };

  return (
    <StyledDateRange {...props}>
      {start.setHours(0, 0, 0, 0) !== end.setHours(0, 0, 0, 0) && (
        <>
          <time dateTime={startDate}>
            {startDay !== endDay && formatDay(startDay)}
            {startMonth !== endMonth && ` ${startMonth}`}
            {startYear !== endYear && ` ${startYear}`}
          </time>
          {` - `}
        </>
      )}
      <time dateTime={endDate}>
        {formatDay(endDay)} {endMonth} {endYear}
      </time>
    </StyledDateRange>
  );
};
